export default __webpack_public_path__ + "static/media/pathway-to-mastery.a66ba905.png";